import { render, staticRenderFns } from "./DocTable.vue?vue&type=template&id=2508c782&scoped=true&"
import script from "./doctable.js?vue&type=script&lang=js&"
export * from "./doctable.js?vue&type=script&lang=js&"
import style0 from "./DocTable.vue?vue&type=style&index=0&id=2508c782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508c782",
  null
  
)

export default component.exports